/**
 * Created by CADesign.
 * User: Vladimir
 * Date: 15.10.2019
 * Time: 16:30
 */

window.ajaxCallback = [];

$(document).on("submit", ".ajax-form", function (e)
{
    e.preventDefault();

    if (0 === validateForm($(this))) return false;
    var formData = new FormData($(this)[0]);

    var cb;
    if (typeof formData.get("ajaxCallback") !== "undefined")
        cb = window.ajaxCallback[formData.get("ajaxCallback")];
    else
        cb = function (container)
        {
        };
    window.sendAjax(formData, $(this), cb);
});

function validateForm(form)
{
    $(form).find(".error").removeClass("error");
    var send = 1;
    $(form).find("[data-required]").each(function ()
    {
        if ($(this).val() === "" || $(this).val() === "Заполните поле")
        {
            $(this).val("Заполните поле").closest(".input-block").addClass("error");
            send = 0;
        }
    });

    return send;
}

var sendAjax = window.sendAjax = function (data, container, cb)
{
    $.ajax({
        type: "POST", url: "/ajax/",
        data: data, dataType: "json",
        cache: false, contentType: false, processData: false,
        success: function (data)
        {
            if (typeof cb === 'function')
                cb(container, data);
        }
    });
};

window.ajaxCallback.afterSubmitFeedback = function ($form, result)
{
    const $this = $form,
        modalEl = $this.closest('[data-modal]');

    if (modalEl.length)
    {
        const modalId = modalEl.data('modal');
        modal.close(modalId);
    }

    clearForm($this);

    modal.open('thanks');
};


var clearForm = window.clearForm = function (form)
{
    form.find("input:visible, textarea:visible").val("");
};

$(document).on("click", "[data-modal-open=order]", function ()
{
    const $this = $(this),
        $modal = $("[data-modal=order]"),
        $item = $this.closest(".tariff-item");
    var title = $item.find(".tariff-item__title").clone();
    var price = $item.find(".tariff-item__price").clone();

    $modal.find(".modal__title").text(title.text());
    $modal.find(".modal__order-price").html(price.html());
    $modal.find("[name=tariff_name]").val(title.text());
    $modal.find("[name=tariff_price]").val(price.text().replace('/мес.', ''));

});